import { useReactiveVar } from '@apollo/client'

import { userVar } from 'src/reactive-variables'

// TODO: looks like this to functions are duplicates. Need to fix it later
export const useMe = () => useReactiveVar<$TSFixMe>(userVar)
